import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { StatusChip } from "@/components/common/StatusChip";
import { Skeleton } from "@/components/ui/skeleton";
import { EmptyState } from "@/components/common/EmptyState";
import { Button } from "@/components/ui/button";
import { ListOrdered } from "lucide-react";

export default function BookingsList() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/bookings").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  if (items === null)
    return <div className="space-y-2">{[0, 1, 2].map((i) => <Skeleton key={i} className="h-20" />)}</div>;
  if (items.length === 0)
    return (
      <EmptyState
        icon={ListOrdered}
        title="No bookings yet"
        description="Your requested and completed sessions will show up here."
        cta={<Link to="/request"><Button>Request a ball boy</Button></Link>}
      />
    );

  return (
    <div className="space-y-2">
      {items.map((b) => (
        <Link
          key={b.id}
          to={`/bookings/${b.id}`}
          className="block rounded-xl border border-border bg-card p-3 hover:bg-muted/60"
          data-testid="booking-list-row"
        >
          <div className="flex justify-between items-start">
            <div>
              <div className="text-sm font-medium capitalize bb-display">{b.sport}</div>
              <div className="text-xs text-muted-foreground">{new Date(b.start_at).toLocaleString()}</div>
              {b.counterpart?.name && (
                <div className="text-xs text-muted-foreground mt-0.5">with {b.counterpart.name}</div>
              )}
            </div>
            <div className="text-right space-y-1">
              <StatusChip status={b.status} />
              <div className="text-sm font-semibold tabular-nums">${b.price_total?.toFixed?.(2)}</div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
